import {Options} from "@material-table/core";
import {QuotationDraftSchema} from "@feature/quotations";


export const OPTIONS: Options<QuotationDraftSchema> = {
  filtering: false,
  search: false,
  sorting: true,
  pageSize: 5,
  filterCellStyle: { maxWidth: 250 },
  headerStyle: { whiteSpace: "nowrap", fontWeight: "bold" },
  // @ts-ignore
  cellStyle: { padding: 0, textTransform: "uppercase" },
};